export const SLIDING_RIGHT_PANEL_STATE: string = 'slidingRightPanel/toggleState';
